import Cookies from 'js-cookie'

export default function authHeader() {
  const token = Cookies.get('intelli:token')

  if (token) {
    return { Authorization: 'Bearer ' + token }
  } else {
    return {}
  }
}
